import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "flag",
  "use": "flag-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"flag\"><path d=\"M0 0h64v512H0V0zM416 321.501c41.312 0 77.285-9.992 96-24.75v-256c-18.715 14.759-54.688 24.751-96 24.751s-77.285-9.992-96-24.751v256c18.715 14.758 54.688 24.75 96 24.75zM304 16.264C280.547 6.294 246.24 0 208 0c-48.198 0-90.167 9.992-112 24.751v256C117.833 265.992 159.802 256 208 256c38.24 0 72.547 6.294 96 16.264v-256z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/flag.svg
// module id = IjyR
// module chunks = 1